<kt-subheader4 *ngIf="layout === 'subheader-v4'" [fluid]="fluid" [clear]="clear"></kt-subheader4>
